import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcPhone, FcStackOfPhotos } from "react-icons/fc";
import SimpleButton from "../../Components/layouts/simple_button";

const ViewCallDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  let { id } = useParams();

  // ==========================================
  // GET CALL DETAILS
  // ==========================================

  useEffect(() => {
    setLoading(true);

    performRequest("GET", `/get-call/getaivoiceagentdataById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.aiVoiceData);
        } else {
          Toast("error", "Error while fetching call details");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  // ==========================================
  // LOADING
  // ==========================================

  if (loading) {
    return <LoadingPage />;
  }

  // ==========================================
  // TRANSCRIPT FORMAT
  // ==========================================

  const transcript =
    data?.ai_transcript
      ?.split("\n")
      ?.filter((line) => line.trim())
      ?.map((line) => {
        if (line.startsWith("assistant:")) {
          return {
            speaker: "Aarya",
            message: line.replace("assistant:", "").trim(),
          };
        }

        return {
          speaker: "Customer",
          message: line.replace("user:", "").trim(),
        };
      }) || [];

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          {/* HEADER */}

          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcPhone className="fs-2 me-1" />
                  Call Details
                </h2>

                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>

          {/* MAIN CARD */}

          <div className="card my-4">
            {/* CARD HEADER */}

            <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h2 className="page-title">View Call Details</h2>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <span
                  className="badge bg-success fs-8 p-2"
                  style={{ color: "#fff" }}
                >
                  {data?.status || "completed"}
                </span>

                <span
                  className="badge bg-primary fs-8 p-2"
                  style={{ color: "#fff" }}
                >
                  {data?.call_type || "outbound"}
                </span>
              </div>
            </div>

            {/* CARD BODY */}

            <div className="card-body">
              {/* CUSTOMER NAME */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Customer Name :</label>

                <div className="w-100 col">{data?.customer_name || "N/A"}</div>
              </div>

              {/* PHONE NUMBER */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Customer Number :
                </label>

                <div className="w-100 col">{data?.user_number || "N/A"}</div>
              </div>

              {/* CITY */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">City :</label>

                <div className="w-100 col">{data?.city || "N/A"}</div>
              </div>

              {/* LANGUAGE */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Preferred Language :
                </label>

                <div className="w-100 col">
                  {data?.preferred_language || "N/A"}
                </div>
              </div>

              {/* DURATION */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Duration :</label>

                <div className="w-100 col">{data?.duration || 0} sec</div>
              </div>

              {/* COST */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Total Cost :</label>

                <div className="w-100 col">₹ {data?.total_cost || 0}</div>
              </div>

              {/* PROVIDER */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Provider :</label>

                <div className="w-100 col">{data?.provider || "N/A"}</div>
              </div>

              {/* INTERESTED IN */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Interested In :</label>

                <div className="w-100 col">
                  <div className="d-flex flex-wrap gap-2">
                    {data?.interested_in?.length > 0 ? (
                      data.interested_in.map((item, index) => (
                        <span key={index} className="badge bg-primary">
                          {item}
                        </span>
                      ))
                    ) : (
                      <span>N/A</span>
                    )}
                  </div>
                </div>
              </div>

              {/* SUMMARY */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Summary :</label>

                <div className="w-100 col">{data?.summary || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Enquiry Quality :
                </label>

                <div className="w-100 col">{data?.lead_quality || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Customer Stage :
                </label>

                <div className="w-100 col">{data?.customer_stage || "N/A"}</div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Customer Sentiment :
                </label>

                <div className="w-100 col">
                  {data?.customer_sentiment || "N/A"}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">
                  Follow Up Required :
                </label>

                <div className="w-100 col">
                  {data?.follow_up_required ? "Yes" : "No" || "N/A"}
                </div>
              </div>

              {/* RECORDING */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Recording :</label>

                <div className="w-100 col">
                  {data?.recording_url ? (
                    <>
                      <audio controls className="w-100">
                        <source src={data?.recording_url} type="audio/mpeg" />
                      </audio>

                      <div className="mt-2">
                        <a
                          href={data?.recording_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary btn-sm me-2"
                        >
                          Open Recording
                        </a>

                        <a
                          href={data?.recording_url}
                          download
                          className="btn btn-outline-secondary btn-sm"
                        >
                          Download
                        </a>
                      </div>
                    </>
                  ) : (
                    <span className="text-muted">Recording Not Available</span>
                  )}
                </div>
              </div>

              {/* TRANSCRIPT */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Transcript :</label>

                <div className="w-100 col">
                  <div
                    className="border rounded p-3"
                    style={{
                      maxHeight: "700px",
                      overflowY: "auto",
                      background: "#f8fafc",
                    }}
                  >
                    {transcript.length > 0 ? (
                      transcript.map((chat, index) => (
                        <div
                          key={index}
                          className={`d-flex mb-3 ${
                            chat.speaker === "Aarya"
                              ? "justify-content-start"
                              : "justify-content-end"
                          }`}
                        >
                          <div
                            className={`p-3 rounded shadow-sm ${
                              chat.speaker === "Aarya"
                                ? "bg-primary text-white"
                                : "bg-light border"
                            }`}
                            style={{
                              maxWidth: "80%",
                            }}
                          >
                            <div
                              className="fw-bold mb-1"
                              style={{
                                fontSize: "14px",
                              }}
                            >
                              {chat.speaker}
                            </div>

                            <div>{chat.message}</div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-muted">Transcript Not Available</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewCallDetails;
